import type { StateCreator } from 'zustand'
import type { ChatMessage, ToolCallFeito } from '@modules/assistant/lib/chat'

// Conversa do assistente, tirada do `useState` da página para o store
// global. É o mesmo bug que a Tabela pagou no beta.76 e o IDS a seguir:
// a casca do workspace desmonta a página do módulo sempre que se sai
// dela, e com estado local a conversa inteira ia ao ar. Sair para ver
// uma coisa no 3D e voltar obrigava a recomeçar do zero, incluindo o
// contexto que o modelo já tinha sobre o modelo aberto.
//
// PERSISTÊNCIA (regra do beta.75): nada disto vai para localStorage. Uma
// conversa é trabalho da sessão, não uma preferência, e o que ficou
// escrito sobre o modelo de um cliente não deve sobreviver ao browser
// sozinho. O "Fechar sessão" limpa-a como limpa o resto.

/** Uma volta da conversa, como a interface a mostra. O histórico que vai
 *  ao modelo é outro (`ChatMessage[]`, com os blocos de ferramentas). */
export interface AssistantTurno {
  pergunta: string
  resposta: string
  ferramentas: ToolCallFeito[]
  erro?: string
}

export interface AssistantSlice {
  assistantTurnos: AssistantTurno[]
  /** O que vai ao modelo, com os blocos de uso de ferramentas. */
  assistantHistorico: ChatMessage[]
  pushAssistantTurno: (turno: AssistantTurno) => void
  setAssistantHistorico: (h: ChatMessage[]) => void
  resetAssistant: () => void
}

export const createAssistantSlice: StateCreator<
  AssistantSlice,
  [],
  [],
  AssistantSlice
> = (set) => ({
  assistantTurnos: [],
  assistantHistorico: [],
  pushAssistantTurno: (turno) =>
    set((s) => ({ assistantTurnos: [...s.assistantTurnos, turno] })),
  setAssistantHistorico: (h) => set({ assistantHistorico: h }),
  resetAssistant: () => set({ assistantTurnos: [], assistantHistorico: [] }),
})
